const AUTO_LINE_ITEM_ID_PREFIXES = ["AUTO-", "NEW-"];

export const LINE_ITEM_ACTIVE_STATUS = "ACTIVE";
export const LINE_ITEM_INACTIVE_STATUSES = new Set(["VOID", "VOIDED", "REPLACED"]);

export const getVoidReason = (record) => (
    record?.void_reason
    || record?.delete_reason
    || record?.revision_summary?.void_reason
    || record?.invoice_summary?.void_reason
    || record?.additional_info?.void_reason
    || null
);

export const getReplacementId = (record) => (
    record?.replaced_by_ids_id
    || record?.replaced_by_id
    || record?.replaced_by?.id
    || record?.replacement_ids_id
    || null
);

export const getReplacementLabel = (record) => (
    record?.replaced_by_invoice_number
    || record?.replaced_by_ids_number
    || record?.replaced_by?.invoice_number
    || record?.replaced_by?.original_filename
    || getReplacementId(record)
);

export const getReplacesId = (record) => (
    record?.replaces_ids_id
    || record?.replaces_id
    || record?.replaces?.id
    || null
);

export const getReplacesLabel = (record) => (
    record?.replaces_invoice_number
    || record?.replaces_ids_number
    || record?.replaces?.invoice_number
    || record?.replaces?.original_filename
    || getReplacesId(record)
);

export const getLineItemLifecycleStatus = (lineItem) => (
    String(lineItem?.lifecycle_status || LINE_ITEM_ACTIVE_STATUS).toUpperCase()
);

export const isLineItemActive = (lineItem) => getLineItemLifecycleStatus(lineItem) === LINE_ITEM_ACTIVE_STATUS;

export const isLineItemInactive = (lineItem) => LINE_ITEM_INACTIVE_STATUSES.has(getLineItemLifecycleStatus(lineItem));

export const resolveLineItemId = (lineItem) => (
    lineItem?.line_item_id
    || lineItem?.id
    || lineItem?.item_id
    || null
);

export const hasPersistedLineItemId = (lineItem) => {
    const id = resolveLineItemId(lineItem);
    if (!id) return false;
    const text = String(id);
    return !AUTO_LINE_ITEM_ID_PREFIXES.some((prefix) => text.startsWith(prefix));
};
